// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as VehicleActions from '../actions/vehicles-detail.actions';
import { VehicleStats } from '../../service/vehicle-statistics-api.service';
import { VehicleType, VehicleTypeDetail } from '@fc-core';

export const vehiclesDetailFeatureKey = 'vehicles-detail';

export interface State {
  vehicleTypes: VehicleType[];
  vehicleStats: VehicleStats;
  vehicleTypeDetail: VehicleTypeDetail;
  loading: boolean;
}

export const initialState: State = {
  vehicleTypes: [],
  vehicleStats: null,
  vehicleTypeDetail: null,
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(VehicleActions.getVehicleStatsSuccess, (state, action) => ({
    ...state,
    vehicleStats: action.vehicleStats,
  })),
  on(VehicleActions.getVehicleTypeDetailsSuccess, (state, action) => ({
    ...state,
    vehicleTypeDetail: action.typeDetail,
  })),
  on(VehicleActions.addSpecToVehicle, (state) => ({
    ...state,
    loading: true,
  })),
  on(VehicleActions.addSpecToVehicleSuccess, (state) => ({
    ...state,
    loading: false,
  })),
);

export const getVehicleStats = (state: State) => state.vehicleStats;
export const getVehicleLoading = (state: State) => state.loading;
export const getVehicleTypeDetail = (state: State) => state.vehicleTypeDetail;
